export const environment = {
  production: true,
  oauth_url: 'https://request.itgis.innovateteam.com/api/oauth2',
  local_service_endpoint: '/api',
  recaptcha_siteKey: '6Ld14wcqAAAAAKrUfTlYqyUyuLzkNUSQiiPTxM2N',
  snackbar_duration: 6000
};
